import { render, staticRenderFns } from "./PaymentMethodsCard.vue?vue&type=template&id=16657785&"
import script from "./PaymentMethodsCard.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports